import Button from '@material-ui/core/Button';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { useSelector } from 'react-redux';
import { startMp4Conversion, downloadMp4 } from 'utils/apiCalls';
import PropTypes from 'prop-types';

const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
function bytesToSize(bytes) {
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

const DownloadArchive = ({ mp4s, archives, jobs, getJobs }) => {
  const { sessionId } = useSelector(({ conference }) => ({
    sessionId: conference.SessionId,
  }));

  const columns = [
    {
      name: 'Key',
      label: 'Key',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRender: (key) => {
          let newKey = key.split('/')[2].split('_')[0].substring(0, 10);
          return (
            <div>
              {moment.unix(newKey).format('MMM D, YYYY h:mm:ss a')}
              <br />
            </div>
          );
        },
      },
    },
    {
      name: 'Size',
      label: 'Size',
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customBodyRender: (size) => <div>{bytesToSize(size)}</div>,
      },
    },
    {
      name: 'Key',
      label: 'Start Conversion',
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customBodyRender: (key) => {
          return (
            <div>
              <Button
                onClick={async () => {
                  try {
                    await startMp4Conversion(key, sessionId);
                    setTimeout(async () => await getJobs(), 1000);
                  } catch (err) {
                    console.log(err);
                  }
                }}
                variant="contained"
              >
                Start conversion to mp4
              </Button>
            </div>
          );
        },
      },
    },
  ];

  const mp4columns = [
    {
      name: 'Key',
      label: 'Key',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRender: (key) => {
          let newKey = key.split('/')[2].split('_')[0].substring(0, 10);
          return (
            <div>
              {moment.unix(newKey).format('MMM D, YYYY h:mm:ss a')}
              <br />
            </div>
          );
        },
      },
    },
    {
      name: 'Size',
      label: 'Size',
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customBodyRender: (size) => <div>{bytesToSize(size)}</div>,
      },
    },
    {
      name: 'Key',
      label: 'Download',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRender: (key) => (
          <div>
            <Button
              onClick={async () => {
                const resp = await downloadMp4(key.split('/')[2], sessionId);
                console.log(resp.url);
                const link = document.createElement('a');
                link.href = resp.url;
                // link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              variant="contained"
              color="primary"
            >
              download
            </Button>
          </div>
        ),
      },
    },
  ];

  const jobcolumns = [
    {
      name: 'UserMetadata',
      label: 'Date',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRender: (UserMetadata) => {
          return (
            <div>
              {moment.unix(UserMetadata.date).format('MMM D, YYYY h:mm:ss a')}
              <br />
            </div>
          );
        },
      },
    },
    {
      name: 'JobPercentComplete',
      label: 'Percent Complete',
      options: {
        filter: false,
        sort: false,
        searchable: false,
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    sortOrder: { name: 'name', direction: 'asc' },
    filterType: 'select',
    selectableRows: false,
  };

  return (
    <>
      <MUIDataTable
        style={{ width: '100%' }}
        title="Finished MP4s"
        data={mp4s}
        columns={mp4columns}
        options={options}
      />
      <MUIDataTable
        style={{ width: '100%' }}
        title="In Progress"
        data={jobs}
        columns={jobcolumns}
        options={options}
      />
      <MUIDataTable
        style={{ width: '100%' }}
        title="Archived Streams"
        data={archives}
        columns={columns}
        options={options}
      />
    </>
  );
};

DownloadArchive.propTypes = {
  SessionId: PropTypes.string,
  mp4s: PropTypes.array,
  archives: PropTypes.array,
  jobs: PropTypes.array,
  getJobs: PropTypes.func,
};

export default DownloadArchive;
